import React, { Component, Fragment, useEffect, useState, useRef } from 'react';
import './style.css';
import { useHistory, Link } from "react-router-dom"
import { Layout, Menu, Breadcrumb, Table, Button, Space, Form, Input, Row, Col, Checkbox, Divider, Card, Radio, Spin, Select } from 'antd';
import { MinusCircleOutlined, PlusOutlined, SearchOutlined, MoreOutlined, SyncOutlined } from '@ant-design/icons';
import Container from '../Layout/Container';
import { Wizard, Steps, Step } from 'react-albus';
import { useSelector, useDispatch } from 'react-redux';
import { addDepartment, addDepartmentSelector, clearState } from './addDepartmentSlice';
import { getUserDepartments } from '../Department/departmentSlice';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
const { Header, Content, Footer } = Layout;
const { Search, TextArea } = Input;
const { Option } = Select;
const CheckboxGroup = Checkbox.Group;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const plainOptions = ['Branch', 'Independent Office', 'Independent Directorate'];
const defaultCheckedList = [];

export default function AddDepartment() {
  const inputAddBranch = React.useRef(null);

  const [isLoading, setLoading] = React.useState(false);
  const [checkedList, setCheckedList] = React.useState(defaultCheckedList);
  const [indeterminate, setIndeterminate] = React.useState(true);
  const [checkAll, setCheckAll] = React.useState(false);
  const [directorate, setDirectorate] = React.useState(false);
  const dispatch = useDispatch();
  let history = useHistory()
  const [refno, setRefNo] = React.useState('');
  const [brefno, setbRefNo] = React.useState('');
  const [state, setState] = useState({})

  const [branchRef1, setBranchRef1] = React.useState(null);
  const [branchRef, setBranchRef] = useState([]);
  const [branchRefArr, setBranchRefArr] = useState([]);

  const [branchDirRef, setBranchDirRef] = useState([]);

  const [brDirectorate, setBrDirectorate] = React.useState(false);
  const [brDirectorateName, setBrDirRefname] = React.useState(null);
  const [brDirectorateDes, setBrDireDesRef] = useState(null);
  const [brDirectorateArr, setbrDirRefArr] = useState([]);

  const [drrefno, setdrRefNo] = React.useState('');
  const [iorefno, setioRefNo] = React.useState('');

  let branchKey = 1;

  let branchDirKey = 1;
  const [branch1, setBranch1] = React.useState('');
  const [branch1Des, setBranch1Des] = React.useState('');
  const [branch1Ref, setBranch1Ref] = React.useState('');
  const { isFetching, isSuccess, isError, errorMessage, adddepartment } = useSelector(
    addDepartmentSelector
  );

  useEffect(() => {
    dispatch(clearState());
    // setTimeout(() => {
    //   setDirectorate(true);
    // }, 5000);

  }, []);

  useEffect(() => {

    if (isError) {
      dispatch(clearState());
      setLoading(false);

      toast.error(errorMessage);

    }
    if (isSuccess) {
      dispatch(clearState());
      dispatch(getUserDepartments());

      setTimeout(() => {
        setLoading(false);
        history.push('/departments');
      }, 1000);


    }
  }, [isError, isSuccess, setLoading]);

  const onChange = list => {
    // console.log(list)

    setCheckedList(list);
    setIndeterminate(!!list.length && list.length < plainOptions.length);
    //setCheckAll(list.length === plainOptions.length);
    //inputAddBranch.current.click();
    // inputAddBranch.current.click()
    //console.log(inputAddBranch)
  };


  // const onChangeDirectorate = e => {
  //   console.log('radio checked', e.target.value);
  //   setDirectorate(e.target.value);
  // };

  const onChangeDirectorate = (e, name) => {
    // const { target: {value, name } } = e
    let value = e.target.value;

    setState(prev => ({
      ...prev,
      [name]: value
    }));


  }

  const removeDir = n => {
    // console.log(n)
    n.hide();
    //   var elem = document.getElementById(n);
    //  // elem.removeChild(elem);
    //   elem.style.display = 'none';
    //  elem.parentNode.removeChild(elem);
  }

  const onCheckAllChange = e => {
    setCheckedList(e.target.checked ? plainOptions : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  var isBranchChecked = checkedList.length ? checkedList.filter((val) => val.includes('Branch')).length ? true : false : false;
  var isIndOffChecked = checkedList.length ? checkedList.filter((val) => val.includes('Independent Office')).length ? true : false : false;
  var isIndDirChecked = checkedList.length ? checkedList.filter((val) => val.includes('Independent Directorate')).length ? true : false : false;

  const onFinish1 = values => {
    let bddirectorates = [];
    if (brDirectorate) {
      bddirectorates.push({ bd_name: brDirectorateName, bd_referenceNumber: brDirectorateArr, bd_description: brDirectorateDes })
    }

    let brData = [];
    if (branchRef1 && branchRefArr) branchRefArr.unshift(branchRef1);
    let initialbrData = { b_name: branch1, b_referenceNumber: branchRefArr, b_description: branch1Des, b_directorate: brDirectorate ? true : false, bd_directorates: bddirectorates };
    brData.push(initialbrData);
    if (values.branch_data) {
      let branchdata = values.branch_data.map((v, i) => {

        if (i == 0) {
          let breferenceNumber = v.b_referenceNumber;
          if (breferenceNumber) breferenceNumber.unshift(brefno);
          else v.b_referenceNumber = [brefno];

        }

        if (!v.b_directorate) v.b_directorate = false;

        v.b_directorate = false;
        let bdDirectorates = [];
        if (v.bd_directorates) {
          v.b_directorate = true;
          bdDirectorates.push({ bd_name: v.bd_directorates[i].bd_name, bd_description: v.bd_directorates[i].bd_description, bd_referenceNumber: [v.bd_directorates[i].bd_referenceNumber] });

        }
        v.bd_directorates = bdDirectorates
        brData.push(v);
      })
    }

    let indOffArr = [];
    if (isIndOffChecked) {
      if (values.io_independentOffices) {
        let iodata = values.io_independentOffices.map((v, i) => {

          if (i == 0) {
            let io_referenceNumber = v.io_referenceNumber;
            if (io_referenceNumber) io_referenceNumber.unshift(iorefno);
            else v.io_referenceNumber = [iorefno];

          }
          indOffArr.push(v);
        })
      }
      // let indOff = {io_name:values.io_name,io_referenceNumber:[values.io_referenceNumber],io_description:values.io_description}
      // indOffArr.push(indOff);
    }

    let indDIRArr = [];
    if (isIndDirChecked) {
      if (values.id_directorates) {
        let iodata = values.id_directorates.map((v, i) => {

          if (i == 0) {
            let id_referenceNumber = v.id_referenceNumber;
            if (id_referenceNumber) id_referenceNumber.unshift(drrefno);
            else v.id_referenceNumber = [drrefno];

          }
          indDIRArr.push(v);
        })
      }
      // let indDir = {id_name:values.id_name,id_referenceNumber:[values.id_referenceNumber],id_description:values.id_description}
      // indDIRArr.push(indDir);
    }

    let b_directorate = values.b_directorate;
    let referenceNumber = values.referenceNumber;
    if (referenceNumber) referenceNumber.unshift(refno);
    var isBranch = checkedList.length ? checkedList.filter((val) => val.includes('Branch')).length ? true : false : false;
    let data = {
      "name": values.name,
      "referenceNumber": referenceNumber,
      "description": values.description,
      "branch": isBranch ? true : false,
      "branch_data": brData,
      "independentOffice": isIndOffChecked ? true : false,
      "io_independentOffices": indOffArr,
      "independentDirectorate": isIndDirChecked ? true : false,
      "id_directorates": indDIRArr,
    };
    // console.log('Received values of form:', data);
    setLoading(true);
    dispatch(addDepartment(data));
    // console.log('Received values of form:', data);
    // console.log('Received values of form:', branch1);
    // console.log('Received values of form:', branch1Des);
  };

  const onFinish = values => {

    //console.log(values)

    let referenceNumber = values.arr_referenceNumber.map(function ({ referenceNumber }) {
      return referenceNumber;
    });
    let brData = [];
    let indOffArr = [];
    let indDIRArr = [];

    if (values.branch_data) {
      let branchdata = values.branch_data.map((v, i) => {

        let b_referenceNumber = v.arr_b_referenceNumber.map(function ({ b_referenceNumber }) {
          return b_referenceNumber;
        });
        let bdDir = [];
        if (v.bd_directorates) {
          let bdDirdata = v.bd_directorates.map((d, di) => {

            let bd_referenceNumber = d.arr_bd_referenceNumber.map(function ({ bd_referenceNumber }) {
              return bd_referenceNumber;
            });
            let bdObject = { bd_name: d.bd_name, bd_description: d.bd_description, bd_referenceNumber: bd_referenceNumber };
            bdDir.push(bdObject);
          });
        }

        let bObject = { b_name: v.b_name, b_description: v.b_description, b_referenceNumber: b_referenceNumber, b_directorate: v.b_directorate, bd_directorates: bdDir }
        brData.push(bObject);
      });
    }


    if (values.io_independentOffices) {
      let iodata = values.io_independentOffices.map((v, i) => {

        let io_referenceNumber = v.arr_io_referenceNumber.map(function ({ io_referenceNumber }) {
          return io_referenceNumber;
        });

        let ioObject = { io_name: v.io_name, io_description: v.io_description, io_referenceNumber: io_referenceNumber }
        indOffArr.push(ioObject);
      });
    }

    if (values.id_directorates) {
      let iddata = values.id_directorates.map((v, i) => {

        let id_referenceNumber = v.arr_id_referenceNumber.map(function ({ id_referenceNumber }) {
          return id_referenceNumber;
        });

        let ioObject = { id_name: v.id_name, id_description: v.id_description, id_referenceNumber: id_referenceNumber }
        indDIRArr.push(ioObject);
      });
    }


    var isBranchChecked = checkedList.length ? checkedList.filter((val) => val.includes('Branch')).length ? true : false : false;
    var isIndOffChecked = checkedList.length ? checkedList.filter((val) => val.includes('Independent Office')).length ? true : false : false;
    var isIndDirChecked = checkedList.length ? checkedList.filter((val) => val.includes('Independent Directorate')).length ? true : false : false;
    let data = {
      "name": values.name,
      "referenceNumber": referenceNumber,
      "description": values.description,
      "branch": isBranchChecked ? true : false,
      "branch_data": isBranchChecked ? brData : [],
      "independentOffice": isIndOffChecked ? true : false,
      "io_independentOffices": isIndOffChecked ? indOffArr : [],
      "independentDirectorate": isIndDirChecked ? true : false,
      "id_directorates": isIndDirChecked ? indDIRArr : [],
    };

    setLoading(true);
    dispatch(addDepartment(data));

  }

  const onFinishFailed = (errorInfo) => {

    // console.log('Failed:', errorInfo);
  };


  const addBranchRef = () => {
    let bRef = branchRef.length + 1;
    // let brRefArr = branchRef.push(bRef);
    // setBranchRef(brRefArr);
    setBranchRef([...branchRef, bRef]);
    //  setBranchRefArr([...branchRefArr, bRef]);
  }

  const addBranchDirRef = () => {
    let bRef = branchDirRef.length + 1;
    // let brRefArr = branchRef.push(bRef);
    // setBranchRef(brRefArr);
    setBranchDirRef([...branchDirRef, bRef]);
  }

  const addBrDirRef = (v, index) => {
    //setBranchRefArr([...branchRefArr, bRef]);
    // const brArr = { ...branchRefArr };
    const brArr = [...branchDirRef];
    brArr[index] = v;
    setBranchDirRef(brArr);
  }

  const removeBrDirRef = (index) => {
    const reducedArr = [...branchDirRef];
    reducedArr.splice(index, 1)
    setBranchDirRef(reducedArr);

  }

  const removeBrRef = (index) => {
    const reducedArr = [...branchRef];
    reducedArr.splice(index, 1)
    setBranchRef(reducedArr);

    const reducedbArr = [...branchRefArr];
    reducedbArr.splice(index, 1);
    setBranchRefArr(reducedArr);
    // console.log(reducedbArr)

  }

  const addBrRef = (v, index) => {
    //setBranchRefArr([...branchRefArr, bRef]);
    // const brArr = { ...branchRefArr };
    const brArr = [...branchRefArr];
    brArr[index] = v;
    setBranchRefArr(brArr);
  }

  const bdDirRemove = (v) => {
    // console.log(v)
    const FormItem = Form.Item;
    // console.log(FormItem)
  }
  return (
    <>
      <Container>
        <Breadcrumb style={{ margin: '16px 0', paddingLeft: 50, marginBottom: 0 }} separator=">">
          <Breadcrumb.Item>Departments</Breadcrumb.Item>
          <Breadcrumb.Item>Add Department</Breadcrumb.Item>
        </Breadcrumb>

        <div className="site-layout-content" style={{ marginTop: 0, paddingTop: 0 }}>

          <div style={{ padding: 24, paddingTop: 16 }}>
            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%', position: 'fixed', zIndex: 1, left: 0, right: 0, top: '45%', bottom: 0 }} spinning={isLoading} />
            <div>
              <Row style={{ paddingTop: 35, paddingBottom: 20, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderTop: '1px solid #dfe0eb', borderBottom: '2px solid #e8e8e8' }}>
                <Col span="6"></Col>
                <Col span="9" >
                  <h1 style={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: 24 }}>Add Department</h1>
                </Col>
                <Col span="9" style={{ paddingLeft: 25 }}>

                </Col>
              </Row>
              <Form
                layout="vertical"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 16 }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Row style={{ paddingTop: 24, paddingBottom: 80, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderBottom: '1px solid #dfe0eb', marginBottom: 10 }}>
                  <Col span="6"></Col>
                  <Col span="18"  >
                    <Form.Item >
                      <h2 style={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: 22 }}>Department Details</h2>
                    </Form.Item>
                    <Form.Item
                      rules={[{ required: true, message: 'Name is required' }]}
                      requiredMark={'optional'}
                      name={'name'} label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>Name*</p>}  >
                      <Input className="formInput" placeholder="" />
                    </Form.Item>
                    {/* 
              <Form.Item 
              style={{marginTop:30}}
              rules={[{ required: true, message: 'Reference no is required' }]}
              requiredMark={'optional'}
              name={'referenceNumber'} label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0}}>Reference No*</p>}  >
                <Input className="formInput" placeholder="" />
              </Form.Item> */}

                    <Form.List name="arr_referenceNumber" initialValue={[{ referenceNumber: '' }]} >
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map(({ key, name, fieldKey, ...restField }) => (
                            <Form.Item
                              {...restField}
                              name={[name, 'referenceNumber']}

                              label={key == 0 ? <Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}>Reference No*</p></Col><Col style={{ textAlign: 'right' }} span={6}><Button style={{ marginBottom: -2, marginTop: 12, padding: 0, fontSize: 18, fontWeight: 500 }} onClick={() => add()} type="link">+ ADD</Button></Col></Row> : <Row style={{ width: '100%', marginBottom: -25 }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}>Reference No*</p></Col><Col style={{ textAlign: 'right' }} span={6}><Button style={{ marginBottom: -2, marginTop: 12, padding: 0, fontSize: 18, fontWeight: 500 }} onClick={() => remove(name)} type="link"><MinusCircleOutlined /></Button></Col></Row>}
                              fieldKey={[fieldKey, 'referenceNumber']}
                              rules={[{ required: true, message: 'Reference No is required' }]}
                              requiredMark={'optional'}
                            >
                              <Input className="formInput" placeholder="" />
                            </Form.Item>
                          ))}
                        </>
                      )}
                    </Form.List>

                    <Form.Item
                      name={'description'}
                      label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}>Description</p>}
                    >
                      <TextArea rows={4} className="formInput" placeholder="" />
                    </Form.Item>

                    <Form.Item
                      name={'branch'}
                      label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}>What do you want to add?</p>}
                    >
                      <CheckboxGroup options={plainOptions} value={checkedList} onChange={onChange} />
                    </Form.Item>
                    <>
                      {isBranchChecked &&
                        <>
                          <Form.Item >
                            <hr style={{ borderTop: "1px solid #dfe1e6" }} />
                          </Form.Item>

                          <Form.List name="branch_data" initialValue={[{ b_name: '', b_referenceNumber: '', b_description: '', b_directorate: true }]}>
                            {(fields, { add, remove }) => (
                              <>
                                <Form.Item >
                                  <Row style={{ width: '100%' }}><Col span={18}> <h2 style={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: 22 }}>Branch</h2></Col><Col style={{ textAlign: 'right' }} span={6}><Button style={{ marginBottom: -2, marginTop: -5, padding: 0, fontSize: 18, fontWeight: 500 }} onClick={() => add()} ref={inputAddBranch} type="link">+ ADD BRANCH</Button></Col></Row>
                                </Form.Item>


                                {fields.map(({ key, name, fieldKey, ...restField }) => (
                                  <>
                                    <Form.Item >
                                      <h2 style={{ fontWeight: '400', fontStyle: 'normal', fontSize: 20 }}>Branch {key + 1} &nbsp;&nbsp;<MinusCircleOutlined onClick={() => remove(name)} /></h2>
                                    </Form.Item>
                                    <Form.Item style={{ marginBottom: 0 }}>

                                      <Form.Item
                                        {...restField}
                                        name={[name, 'b_name']}
                                        rules={[{ required: true, message: 'Name is required' }]}
                                        requiredMark={'optional'}
                                        style={{ display: 'inline-block', width: 'calc(50% - 8px)' }} label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>Name*</p>}  >
                                        <Input className="formInput" placeholder="" />
                                      </Form.Item>

                                      {/* <Form.Item
                  {...restField}
                  name={[name, 'b_referenceNumber']}
                  style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                    label={<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}></Col></Row>}
                  
                  >
                    <Input className="formInput" placeholder=""  />
                  </Form.Item> */}


                                      <Form.List name={[name, 'arr_b_referenceNumber']} initialValue={[{ b_referenceNumber: '' }]}
                                      >

                                        {(b_referenceNumber, { add, remove }) => (
                                          <>
                                            {/* <Row  style={{width:'100%'}}><Col span={18}></Col>
                  <Col style={{textAlign:'right'}} span={6}>
                  <Button style={{position:'absolute',top:-95,right:10,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()}  type="link">+ ADD</Button>
                  </Col>
                  </Row> */}
                                            {b_referenceNumber.map(({ key, name, bfieldKey, ...brestField }) => (
                                              <Form.Item
                                                {...brestField}
                                                name={[name, 'b_referenceNumber']}
                                                rules={[{ required: true, message: 'Reference No is required' }]}
                                                requiredMark={'optional'}
                                                style={{ display: 'inline-block', width: key == 0 ? 'calc(50% - 8px)' : '99%', margin: key == 0 ? '0 8px' : 0 }}
                                                label={key == 0 ? <Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Reference No*</p></Col><Col span={6} style={{ textAlign: 'right' }}> <Button style={{ marginBottom: -5, marginTop: -10, padding: 0, fontSize: 18, fontWeight: 500 }} onClick={() => add()} type="link">+ ADD</Button></Col></Row> : <Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Reference No*</p></Col><Col span={6} style={{ textAlign: 'right' }}><MinusCircleOutlined onClick={() => remove(name)} /></Col></Row>}
                                              >
                                                <Input className="formInput" placeholder="" />
                                              </Form.Item>
                                            ))}

                                          </>
                                        )}

                                      </Form.List>

                                    </Form.Item>

                                    <Form.Item
                                      {...restField}
                                      name={[name, 'b_description']}
                                      label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}>Description</p>}
                                    >
                                      <TextArea rows={4} className="formInput" placeholder="" />
                                    </Form.Item>

                                    <Form.Item
                                      {...restField}
                                      name={[name, 'b_directorate']}
                                      initialValue={true}
                                      label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}>Do you want to add Directorate?</p>}
                                    >
                                      <Radio.Group defaultValue={true} >
                                        <Radio value={true}>Yes</Radio>
                                        <Radio value={false}  >No</Radio>
                                      </Radio.Group>
                                    </Form.Item>

                                    <Form.Item
                                      {...restField}
                                      // name={[name, 'bd_directorates']}
                                      label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}></p>}
                                      // shouldUpdate={(prevValues, currentValues) => {
                                      //   console.log('prevValues')
                                      //  console.log(prevValues)
                                      //  console.log('currentValues')
                                      //  console.log(currentValues)
                                      // }}
                                      shouldUpdate={(prevValues, currentValues) => prevValues.branch_data[key] && prevValues.branch_data[key].b_directorate !== currentValues.branch_data[key].b_directorate}
                                    //shouldUpdate={(prevValues, currentValues) => currentValues.branch_data[key] && currentValues.branch_data[key].b_directorate==true}
                                    >
                                      {({ getFieldValue }) =>
                                        getFieldValue('branch_data')[key] ?
                                          getFieldValue('branch_data')[key].b_directorate === true ? (
                                            <Form.List name={[name, 'bd_directorates']} initialValue={[{ bd_name: '', bd_referenceNumber: '', bd_description: '' }]}>
                                              {(bd_directorates, { add, remove }) => {

                                                return (
                                                  <>
                                                    <Form.Item >
                                                      <Row style={{ width: '100%' }}><Col span={16}> <h2 style={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: 22 }}>Directorate</h2></Col><Col style={{ textAlign: 'right' }} span={8}><Button style={{ marginBottom: -2, marginTop: -5, padding: 0, fontSize: 18, fontWeight: 500 }} onClick={() => add()} type="link">+ ADD DIRECTORATE</Button></Col></Row>
                                                    </Form.Item>

                                                    {bd_directorates.map(nickname => (
                                                      <>
                                                        <span>
                                                          <Form.Item >
                                                            <h2 style={{ fontWeight: '400', fontStyle: 'normal', fontSize: 20 }}>Directorate {nickname.key + 1} &nbsp;&nbsp;<MinusCircleOutlined onClick={() => remove(nickname.name)} /></h2>
                                                          </Form.Item>
                                                          <Form.Item style={{ marginBottom: 0 }}>

                                                            <Form.Item
                                                              {...nickname}
                                                              name={[nickname.name, 'bd_name']}
                                                              rules={[{ required: true, message: 'Name is required' }]}
                                                              requiredMark={'optional'}
                                                              initialValue={''}
                                                              style={{ display: 'inline-block', width: 'calc(50% - 8px)' }} label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>Name*</p>}  >
                                                              <Input className="formInput" placeholder="" />
                                                            </Form.Item>

                                                            {/* <Form.Item
                  {...nickname}
                  name={[nickname.name, 'bd_referenceNumber']}
                  initialValue={' '}
                  style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                    label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p>}
                  >
                    <Input className="formInput" placeholder="" />
                  </Form.Item> */}

                                                            <Form.List name={[nickname.name, 'arr_bd_referenceNumber']}
                                                              initialValue={[{ bd_referenceNumber: '' }]}
                                                            >

                                                              {(arr_bd_referenceNumber, { add, remove }) => (
                                                                <>
                                                                  {/* <Row  style={{width:'100%'}}><Col span={18}></Col>
                  <Col style={{textAlign:'right'}} span={6}>
                  <Button style={{position:'absolute',top:-95,right:10,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()}  type="link">+ ADD</Button>
                  </Col>
                  </Row> */}
                                                                  {arr_bd_referenceNumber.map(({ key, name, fieldKey, ...brestField }) => (
                                                                    <Form.Item
                                                                      {...brestField}
                                                                      name={[name, 'bd_referenceNumber']}
                                                                      rules={[{ required: true, message: 'Reference No is required' }]}
                                                                      requiredMark={'optional'}
                                                                      //style={{ display: 'inline-block', width: '99%' }}
                                                                      style={{ display: 'inline-block', width: key == 0 ? 'calc(50% - 8px)' : '99%', margin: key == 0 ? '0 8px' : 0 }}
                                                                      //label={<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p></Col><Col span={6} style={{textAlign:'right'}}><MinusCircleOutlined onClick={() => remove(name)}  /></Col></Row>}
                                                                      label={key == 0 ? <Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Reference No*</p></Col><Col span={6} style={{ textAlign: 'right' }}> <Button style={{ marginBottom: -5, marginTop: -10, padding: 0, fontSize: 18, fontWeight: 500 }} onClick={() => add()} type="link">+ ADD</Button></Col></Row> : <Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Reference No*</p></Col><Col span={6} style={{ textAlign: 'right' }}><MinusCircleOutlined onClick={() => remove(name)} /></Col></Row>}
                                                                    >
                                                                      <Input className="formInput" placeholder="" />
                                                                    </Form.Item>
                                                                  ))}

                                                                </>
                                                              )}

                                                            </Form.List>

                                                          </Form.Item>

                                                          <Form.Item
                                                            {...nickname}
                                                            name={[nickname.name, 'bd_description']}
                                                            initialValue={' '}
                                                            label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}>Description</p>}
                                                          >
                                                            <TextArea rows={4} className="formInput" placeholder="" />
                                                          </Form.Item>
                                                        </span>
                                                      </>
                                                    ))}
                                                  </>
                                                )
                                              }}
                                            </Form.List>
                                          ) : null
                                          : null
                                      }

                                    </Form.Item>


                                    <br />
                                    <>

                                    </>
                                  </>
                                ))}
                              </>
                            )}
                          </Form.List>
                        </>
                      }
                    </>
                    <br />
                    <>
                      {isIndOffChecked &&
                        <>
                          <Form.Item >
                            <hr style={{ borderTop: "1px solid #dfe1e6" }} />
                          </Form.Item>

                          <Form.List name="io_independentOffices" initialValue={[{ io_name: '', io_referenceNumber: '', io_description: '' }]}>
                            {(fields, { add, remove }) => (
                              <>
                                <Form.Item >
                                  <Row style={{ width: '100%' }}><Col span={12}> <h2 style={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: 22 }}>Independent Office</h2></Col><Col style={{ textAlign: 'right' }} span={12}><Button style={{ marginBottom: -2, marginTop: -5, padding: 0, fontSize: 18, fontWeight: 500 }} onClick={() => add()} ref={inputAddBranch} type="link">+ ADD INDEPENDENT OFFICE</Button></Col></Row>
                                </Form.Item>
                                {fields.map(({ key, name, fieldKey, ...restField }) => (
                                  <>
                                    <Form.Item >
                                      <h2 style={{ fontWeight: '400', fontStyle: 'normal', fontSize: 20 }}>Independent Office {key + 1} &nbsp;&nbsp;<MinusCircleOutlined onClick={() => remove(name)} /></h2>
                                    </Form.Item>
                                    <Form.Item style={{ marginBottom: 0 }}>

                                      <Form.Item
                                        {...restField}
                                        name={[name, 'io_name']}
                                        rules={[{ required: true, message: 'Name is required' }]}
                                        requiredMark={'optional'}
                                        style={{ display: 'inline-block', width: 'calc(50% - 8px)' }} label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>Name*</p>}  >
                                        <Input className="formInput" placeholder="" />
                                      </Form.Item>

                                      {/* <Form.Item
                      {...restField}
                      name={[name, 'io_referenceNumber']}
                      initialValue={' '}
                      style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                        label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p>}
                      >
                        <Input className="formInput" placeholder="" />
                      </Form.Item> */}

                                      <Form.List name={[name, 'arr_io_referenceNumber']} initialValue={[{ io_referenceNumber: '' }]}>

                                        {(arr_io_referenceNumber, { add, remove }) => (
                                          <>
                                            {/* <Row  style={{width:'100%'}}><Col span={18}></Col>
                      <Col style={{textAlign:'right'}} span={6}>
                      <Button style={{position:'absolute',top:-95,right:10,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()}  type="link">+ ADD</Button>
                      </Col>
                      </Row> */}
                                            {arr_io_referenceNumber.map(({ key, name, bfieldKey, ...brestField }) => (
                                              <Form.Item
                                                {...brestField}
                                                name={[name, 'io_referenceNumber']}
                                                rules={[{ required: true, message: 'Reference No is required' }]}
                                                requiredMark={'optional'}
                                                style={{ display: 'inline-block', width: key == 0 ? 'calc(50% - 8px)' : '99%', margin: key == 0 ? '0 8px' : 0 }}
                                                label={key == 0 ? <Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Reference No*</p></Col><Col span={6} style={{ textAlign: 'right' }}> <Button style={{ marginBottom: -5, marginTop: -10, padding: 0, fontSize: 18, fontWeight: 500 }} onClick={() => add()} type="link">+ ADD</Button></Col></Row> : <Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Reference No*</p></Col><Col span={6} style={{ textAlign: 'right' }}><MinusCircleOutlined onClick={() => remove(name)} /></Col></Row>}
                                              //style={{ display: 'inline-block', width: '98%', margin: '0 8px' }}
                                              //label={<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p></Col><Col style={{textAlign:'right',paddingRight:1}} span={6}>&nbsp;&nbsp;<MinusCircleOutlined onClick={() => remove(name)}  /></Col></Row>}
                                              >
                                                <Input className="formInput" placeholder="" />
                                              </Form.Item>
                                            ))}

                                          </>
                                        )}

                                      </Form.List>

                                    </Form.Item>

                                    <Form.Item
                                      {...restField}
                                      name={[name, 'io_description']}
                                      label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}>Description</p>}
                                    >
                                      <TextArea rows={4} className="formInput" placeholder="" />
                                    </Form.Item>
                                    <>
                                    </>
                                  </>
                                ))}
                              </>
                            )}
                          </Form.List>
                        </>
                      }
                    </>
                    <br />
                    <>
                      {isIndDirChecked &&
                        <>
                          <Form.Item >
                            <hr style={{ borderTop: "1px solid #dfe1e6" }} />
                          </Form.Item>

                          <Form.List name="id_directorates" initialValue={[{ id_name: '', id_referenceNumber: '', id_description: '' }]}>
                            {(fields, { add, remove }) => (
                              <>
                                <Form.Item >
                                  <Row style={{ width: '100%' }}><Col span={12}> <h2 style={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: 22 }}>Independent Directorate</h2></Col><Col style={{ textAlign: 'right' }} span={12}><Button style={{ marginBottom: -2, marginTop: -5, padding: 0, fontSize: 18, fontWeight: 500 }} onClick={() => add()} ref={inputAddBranch} type="link">+ ADD INDEPENDENT DIRECTORATE</Button></Col></Row>
                                </Form.Item>
                                {fields.map(({ key, name, fieldKey, ...restField }) => (
                                  <>
                                    <Form.Item >
                                      <h2 style={{ fontWeight: '400', fontStyle: 'normal', fontSize: 20 }}>Independent Directorate {key + 1} &nbsp;&nbsp;<MinusCircleOutlined onClick={() => remove(name)} /></h2>
                                    </Form.Item>
                                    <Form.Item style={{ marginBottom: 0 }}>

                                      <Form.Item
                                        {...restField}
                                        name={[name, 'id_name']}
                                        rules={[{ required: true, message: 'Name is required' }]}
                                        requiredMark={'optional'}
                                        style={{ display: 'inline-block', width: 'calc(50% - 8px)' }} label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>Name*</p>}  >
                                        <Input className="formInput" placeholder="" />
                                      </Form.Item>

                                      {/* <Form.Item
                      {...restField}
                      name={[name, 'id_referenceNumber']}
                      initialValue={' '}
                      style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                        label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p>}
                      >
                        <Input className="formInput" placeholder="" />
                      </Form.Item> */}

                                      <Form.List name={[name, 'arr_id_referenceNumber']} initialValue={[{ id_referenceNumber: '' }]}>

                                        {(arr_id_referenceNumber, { add, remove }) => (
                                          <>
                                            {/* <Row  style={{width:'100%'}}><Col span={18}></Col>
                      <Col style={{textAlign:'right'}} span={6}>
                      <Button style={{position:'absolute',top:-95,right:10,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()}  type="link">+ ADD</Button>
                      </Col>
                      </Row> */}
                                            {arr_id_referenceNumber.map(({ key, name, fieldKey, ...brestField }) => (
                                              <Form.Item
                                                {...brestField}
                                                name={[name, 'id_referenceNumber']}
                                                rules={[{ required: true, message: 'Reference No is required' }]}
                                                requiredMark={'optional'}
                                                style={{ display: 'inline-block', width: key == 0 ? 'calc(50% - 8px)' : '99%', margin: key == 0 ? '0 8px' : 0 }}
                                                label={key == 0 ? <Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Reference No*</p></Col><Col span={6} style={{ textAlign: 'right' }}> <Button style={{ marginBottom: -5, marginTop: -10, padding: 0, fontSize: 18, fontWeight: 500 }} onClick={() => add()} type="link">+ ADD</Button></Col></Row> : <Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Reference No*</p></Col><Col span={6} style={{ textAlign: 'right' }}><MinusCircleOutlined onClick={() => remove(name)} /></Col></Row>}
                                              //style={{ display: 'inline-block', width: '98%', margin: '0 8px' }}
                                              //label={<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p></Col><Col style={{textAlign:'right',paddingRight:1}} span={6}>&nbsp;&nbsp;<MinusCircleOutlined onClick={() => remove(name)}  /></Col></Row>}
                                              >
                                                <Input className="formInput" placeholder="" />
                                              </Form.Item>
                                            ))}

                                          </>
                                        )}

                                      </Form.List>

                                    </Form.Item>

                                    <Form.Item
                                      {...restField}
                                      name={[name, 'id_description']}
                                      label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}>Description</p>}
                                    >
                                      <TextArea rows={4} className="formInput" placeholder="" />
                                    </Form.Item>
                                    <>
                                    </>
                                  </>
                                ))}
                              </>
                            )}
                          </Form.List>
                        </>
                      }
                    </>

                  </Col>
                </Row>

                <Row style={{ paddingTop: 24, paddingBottom: 24, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderBottom: '1px solid #dfe0eb', marginBottom: 10 }}>
                  <Col span="6"></Col>
                  <Col span="11" style={{ textAlign: 'right', marginLeft: 12 }}>
                    <Space>
                      <Link to="/departments"><Button type="primary" size="large" ghost>Cancel</Button></Link>
                      <Button htmlType="submit" type="primary" size="large" >Submit</Button>
                    </Space>
                  </Col>
                  <Col span="6"></Col>

                </Row>
              </Form>
            </div>

          </div>

        </div>
      </Container>
    </>
  );
}
